import Stack from './layouts/Stack';
import { number, string, node, oneOfType, bool } from 'prop-types';

const WithLabel = ({ label, children, width, minWidth, maxWidth, space, asDiv }) => (
  <Stack
    as={asDiv ? 'div' : 'label'}
    space={space}
    width={width}
    minWidth={minWidth}
    maxWidth={maxWidth}
  >
    <span>{label}</span>
    {children}
  </Stack>
);

WithLabel.propTypes = {
  label: string.isRequired,
  children: node.isRequired,
  width: oneOfType([string, number]),
  minWidth: oneOfType([string, number]),
  maxWidth: oneOfType([string, number]),
  space: string,
  asDiv: bool,
};

WithLabel.defaultProps = {
  width: 'inherit',
  minWidth: '',
  maxWidth: '',
  space: 's',
};

export default WithLabel;
